export default {
  // Navigation
  "nav.home": "Home",
  "nav.guide": "Buying Guide",
  "nav.explore": "Buy it Now",

  // Hero
  "hero.badge": "Independent Resource Hub",
  "hero.title": "AllChinaBuy Spreadsheet",
  "hero.subtitle": "Find Products, Sellers & Buying Resources",
  "hero.description": "Discover useful AllChinaBuy product resources, seller information, QC guides, shipping tips, warehouse details and buying guides — organized in one simple resource hub.",
  "hero.cta.primary": "allchinabuy spreadsheet",
  "hero.cta.secondary": "Buy it Now",

  // Dropdown
  "dropdown.title": "Browse a Category",
  "dropdown.placeholder": "Select a category to open…",

  // Categories
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies/Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants/Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear/Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // Categories section
  "categories.title": "Popular Spreadsheet Categories",
  "categories.subtitle": "Jump straight to the product category you need.",

  // Intro text module
  "intro.title": "What Is the AllChinaBuy Spreadsheet?",
  "intro.p1": "The AllChinaBuy Spreadsheet is a hand-organized collection of links that helps you browse AllChinaBuy products faster. Instead of typing the same search queries over and over, the spreadsheet groups useful categories — clothing, shoes, bags, accessories and more — so you can jump straight to the section you want.",
  "intro.p2": "Because AllChinaBuy's catalog is large and constantly changing, a well-maintained spreadsheet saves real time. It brings product categories, seller pages and buying guides into one place, which is especially helpful when you are comparing styles or preparing a new haul.",
  "intro.p3": "This hub is an independent resource and is not run by AllChinaBuy. Always double-check product details, seller ratings and shipping options on the official platform before you place an order.",

  // Features
  "features.title": "What You'll Find Inside",
  "features.t1": "Product Categories",
  "features.d1": "Quick links to clothing, footwear, bags, accessories and other popular sections so you can start browsing in one click.",
  "features.t2": "Seller & Product Resources",
  "features.d2": "Pointers to the product and seller pages that matter most when you are researching a new purchase.",
  "features.t3": "QC & Shipping Tips",
  "features.d3": "Practical guidance on quality checks, warehouse choices and shipping options to help you plan smarter.",
  "features.t4": "Buying Guides",
  "features.d4": "Clear, beginner-friendly explanations of how AllChinaBuy works, from search to checkout.",

  // FAQ
  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is AllChinaBuy?",
  "faq.a1": "AllChinaBuy is an international shopping and forwarding platform that helps buyers purchase items from Chinese sellers and ship them worldwide. It offers product search, warehouse storage, quality-check photos and multiple shipping methods.",
  "faq.q2": "What is the AllChinaBuy Spreadsheet?",
  "faq.a2": "It is a curated list of AllChinaBuy category and product links, organized so you can reach shoes, hoodies, bags and other categories directly without searching repeatedly.",
  "faq.q3": "Is the AllChinaBuy Spreadsheet free?",
  "faq.a3": "Yes. This resource hub links out to publicly available category pages and does not charge for browsing.",
  "faq.q4": "How do I use the category links?",
  "faq.a4": "Open the dropdown or tap any category card on this page, and you will be taken straight to the matching AllChinaBuy section on the main website.",
  "faq.q5": "Is AllChinaBuy safe to use?",
  "faq.a5": "AllChinaBuy is a well-known platform, but like any cross-border purchase, you should always verify sellers, read item descriptions carefully and review shipping and refund policies before paying.",
  "faq.q6": "Does this website ship or sell products?",
  "faq.a6": "No. This website is an independent informational hub only. All purchases are completed on the official platform it links to.",

  // Article card
  "articleCard.label": "Latest Guide",
  "articleCard.title": "AllChinaBuy Spreadsheet: The Complete Beginner Guide",
  "articleCard.excerpt": "Learn what the AllChinaBuy Spreadsheet is, how to use it to find products and sellers, and the steps to ship your first order with confidence.",
  "articleCard.read": "Read the Guide",

  // Pillar articles section
  "articles.title": "Pillar Guides",
  "articles.subtitle": "In-depth, original guides to help you shop AllChinaBuy with confidence.",
  "articles.read": "Read Guide",
  "articles.related": "Continue Reading",

  // Final CTA
  "cta.title": "Ready to Start Browsing?",
  "cta.description": "Open the full AllChinaBuy Spreadsheet on the main website and find your next product in seconds.",
  "cta.primary": "Visit Main Website",
  "cta.secondary": "allchinabuy spreadsheet",

  // Footer
  "footer.disclaimer": "This website is an independent informational resource and is not affiliated with AllChinaBuy. Product, seller, shipping and payment information may change at any time — always verify current details on the official platform before purchasing.",
  "footer.rights": "All rights reserved.",

  // Language switcher
  "lang.label": "Language",

  // ===== Article page =====
  "article.title": "AllChinaBuy Spreadsheet: The Complete Beginner Guide",
  "article.updated": "Last updated: August 2026",
  "article.lead": "The AllChinaBuy Spreadsheet is one of the simplest ways to browse products, compare sellers and plan your shipping on AllChinaBuy. In this guide we explain what the spreadsheet is, what it contains and how to use it to shop with more confidence.",

  "article.h2.1": "What Is the AllChinaBuy Spreadsheet?",
  "article.p.1": "The AllChinaBuy Spreadsheet is a curated collection of links that organizes AllChinaBuy's categories into a single, easy-to-navigate list. Instead of remembering long search URLs or typing the same queries again, you open the spreadsheet and jump straight to shoes, hoodies, t-shirts, bags, belts or any other section you need.",
  "article.p.2": "It works like a shortcut directory. Every row points to a live AllChinaBuy category or search page, so the spreadsheet stays useful as long as the platform's URLs remain active.",

  "article.h2.2": "Why Use a Spreadsheet for AllChinaBuy?",
  "article.p.3": "AllChinaBuy's catalog is large, and browsing it without direction can feel overwhelming. A spreadsheet helps in three main ways. First, it saves time by grouping categories in one view. Second, it reduces mistakes because you are less likely to land on the wrong product type. Third, it makes repeat shopping easier — you can return to the same sections whenever you prepare a new haul.",
  "article.p.4": "It is especially useful for new buyers who are still learning how the platform's search and categories are structured.",

  "article.h2.3": "What Categories Are Included?",
  "article.p.5": "The spreadsheet covers the most popular AllChinaBuy categories, including shoes, hoodies and sweaters, t-shirts, jackets, pants and shorts, headwear, matching sets, underwear, jerseys, accessories, bags, belts and perfumes. A catch-all 'other stuff' category is also included for everything that does not fit neatly elsewhere.",
  "article.p.6": "Each category links to its matching section on the main website, so you can open exactly what you need without extra searching.",

  "article.h2.4": "How to Use the Spreadsheet Step by Step",
  "article.p.7": "Start by deciding what you want to buy. Then open the category that matches your item — for example, 'Shoes' for sneakers or 'Bags' for backpacks. Browse the results, open any product you like, and read the seller information and item description before adding anything to your cart.",
  "article.p.8": "When you are ready, choose your warehouse and shipping method, review the quality-check options, and complete checkout on the official platform.",

  "article.h2.5": "Tips for Safer Buying",
  "article.p.9": "Always check a seller's rating and feedback before purchasing. Read product descriptions and size charts carefully, especially for clothing. Use the quality-check photo service when available so you can see the item before it ships. Finally, keep an eye on shipping costs and delivery times, because they vary by method and destination.",

  "article.faq.q1": "Is the AllChinaBuy Spreadsheet official?",
  "article.faq.a1": "No. It is an independent resource that links to publicly available AllChinaBuy pages and is not operated by AllChinaBuy.",
  "article.faq.q2": "Do the links in the spreadsheet cost anything?",
  "article.faq.a2": "No. Browsing the linked categories is free; you only pay if you decide to buy a product on the official platform.",
  "article.faq.q3": "How often is the spreadsheet updated?",
  "article.faq.a3": "The category links are checked periodically to keep them working. Product availability and prices change on the platform itself, so always verify current details there.",
  "article.faq.q4": "Can I request a new category?",
  "article.faq.a4": "The list covers the most popular sections. If a category you need is missing, the 'Other Stuff' section is a good place to look.",

  "article.back": "Back to Home",
  "article.cta.title": "Open the AllChinaBuy Spreadsheet",
  "article.cta.text": "Browse all product categories and start your next order on the main website.",
  "article.cta.button": "Visit Main Website",
};